import React, { ReactNode, useEffect, useState } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { useSessionStore } from "@/store/session.store.ts";
import { useCashierStore } from "@/store/cashier.store";

interface PrivateRouteProps {
  children: ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { authToken } = useSessionStore();

  const cashierId = useCashierStore((state) => state.cashierId);
  const cashier = useCashierStore((state) => state.cashier);

  const navigate = useNavigate();
  const location = useLocation();

  const [checking, setChecking] = useState(true);

  const pathsReturnHome = ["/login", "/cashiers/:id/open"];
  const isClosingCashier = !!matchPath(
    { path: "/cashiers/:id/close", end: true },
    location.pathname
  );

  useEffect(() => {
    if (!authToken) return;
    void import("@/pages/home/layout");
    void import("@/pages/home/page");
    void import("@/pages/home/pages/stores/page");
    void import("@/pages/point-of-sale/layout");
    void import("@/pages/point-of-sale/page");
    void import("@/pages/[others]/layout.tsx");
  }, [authToken]);

  useEffect(() => {
    if (!authToken) {
      if (location.pathname !== "/login") {
        navigate("/login");
      }
      setChecking(false);
      return;
    }

    if (!cashierId || cashier?.status === "closed") {
      if (isClosingCashier) {
        setChecking(false);
        return;
      }

      if (location.pathname !== "/stores") {
        navigate("/stores");
      }
      setChecking(false);
      return;
    }

    if (
      pathsReturnHome.some((p) =>
        matchPath({ path: p, end: true }, location.pathname)
      ) &&
      cashier?.status === "opened"
    ) {
      navigate("/");
      setChecking(false);
      return;
    }

    setChecking(false);
  }, [authToken, cashier, cashierId, isClosingCashier, location.pathname, navigate]);

  if (checking) {
    return null;
  }

  return <>{children}</>;
};
